import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface VPNTrafficStats {
  total_vpn_visits_24h: number;
  unique_vpn_ips_24h: number;
  vpn_post_attempts_blocked: number;
  total_blocked_attempts: number;
  vpn_percentage: number;
  active_vpn_users: number;
}

export const useVPNTrafficStats = () => {
  return useQuery({
    queryKey: ['vpn-traffic-stats'],
    queryFn: async (): Promise<VPNTrafficStats> => {
      // VPN tracking feature disabled - return default values
      return {
        total_vpn_visits_24h: 0,
        unique_vpn_ips_24h: 0,
        vpn_post_attempts_blocked: 0,
        total_blocked_attempts: 0,
        vpn_percentage: 0,
        active_vpn_users: 0
      };
    },
    enabled: false, // Disable this query
    refetchInterval: 30000,
    retry: 3,
    retryDelay: 1000,
  });
};